import { gql } from '@apollo/client';

export * from './impersonateUser.mutation.generated';

export const IMPERSONATE_USER = gql`
  mutation impersonateUser($userId: ID!) {
    impersonateUser(input: { userId: $userId }) {
      success
    }
  }
`;
